import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEn from '../english/en.json';
import translationKa from '../georgian/ka.json';
i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: translationEn,
            },
            ka: {
                translation: translationKa,
            },

        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
